import type { AdministrativeUnitCodebookResponse } from './dto-verification'

export interface AdministrativeUnit {
    label: string
    value: string
}

/**
 * Maps AdministrativeUnitCodebookResponse to a label/value option pair
 * (label = fullName, value = stringified id). Replaces the former
 * AdministrativeUnit model class.
 */
export const toAdministrativeUnit = (
    data: AdministrativeUnitCodebookResponse,
): AdministrativeUnit => ({
    label: data.fullName,
    value: String(data.id),
})
